import { ActionMenu, H4, IconButton, IconName, Option, Stack } from "@introist/react-foundation/v2";
import { IconPickerIcon } from "../../../components/organisms";
import { ReactNode } from "react";

export const DrawerHeader = ({
  title,
  onClose,
  icon,
  actions,
  startAdornment
}: {
  title: string | ReactNode;
  onClose?: () => void;
  actions?: Option[];
  icon?: IconName | React.ReactNode;
  startAdornment?: React.ReactNode;
}) => {
  return (
    <Stack>
      {startAdornment}
      {icon && typeof icon === "string" ? <IconPickerIcon fallbackIcon={icon as IconName} /> : icon}
      {typeof title === "string" ? <H4>{title}</H4> : title}
      <Stack style={{ marginLeft: "auto" }}>
        {actions && <ActionMenu options={actions} />}
        {onClose && <IconButton icon="crossSmall" onClick={onClose} />}
      </Stack>
    </Stack>
  );
};
